import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import ActionButton from "../ActionButton";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ReactComponent as Logo } from "./assets/user.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import instance from "../../store/actions/instance";
import RegisterSuccess from "./RegisteringSuccess";
import RegisterFailed from "./RegisteringFailed";
import MuiPhoneNumber from "material-ui-phone-number";
import { isValidPhoneNumber } from "react-phone-number-input";
import { Button } from "@material-ui/core";
import ComeIn from "./ComeIn";

export class WaitListForm extends Component {
  state = {
    FullName: "",
    NoPeople: null,
    CountryCode: "+965",
    PhoneNumber: null,
    Pregnant: false,
    SpecialNeeds: false,
    NameError: false,
    PeopleNumberRequiredError: false,
    PeopleNumberError: false,
    CountryCodeError: false,
    PhoneNumberError: false,
    loading: false,
    failed: false,
  };
  componentDidMount() {
    window.scrollTo(0, document.body.scrollHeight);
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  is_numeric(str) {
    str = parseInt(str);

    if (!Number.isNaN(str)) return true;
    else return false;
  }
  countries = { Kuwait: "kw", Qatar: "qa" };

  render() {
    if (!this.props.history.location.state) {
      this.props.history.replace("/");
      return null;
    }

    if (this.props.history.location.state.waiting_list === null) {
      return <ComeIn history={this.props.history} />;
    }
    const language = this.props.language;

    if (this.state.failed) {
      return (
        <RegisterFailed
          waiting_list={this.props.history.location.state.waiting_list}
        />
      );
    }
    const country = this.countries[this.props.store.base_country] || "kw";
    const wait_list = this.props.history.location.state.waiting_list;
    return (
      <>
        <div
          style={{ backgroundColor: "white", marginTop: 55 }}
          className="h-100"
        >
          <ProductHeader
            style={{ backgroundColor: "white" }}
            onBack={() => this.props.history.goBack()}
          />
          <div
            className="free-space-58"
            style={{ backgroundColor: "white" }}
          ></div>
          {this.state.loading ? (
            <div className="mt-5">
              <CircularProgress
                color="primary"
                style={{ zIndex: 50, width: 100, height: 100 }}
              />
              <h1>
                {language === "english" ? "Please Wait" : "الرجاء الانتظار"}
              </h1>
            </div>
          ) : (
            <>
              <Logo width="100" height="100" className="mt-4 ml-4" />
              <p className="text-muted mt-3 mb-0 " style={{ fontSize: 22 }}>
                {language == "english"
                  ? "Contact Information"
                  : "بيانات التواصل"}
              </p>

              <p
                className="mx-auto w-75 mb-0"
                style={{ fontSize: 15, color: "#c2c2c2" }}
              >
                {language == "english"
                  ? "We need this information to contact you"
                  : "نحتاج هذي المعلومات لنتواصل معك"}
              </p>
              <div className="w-100 mr-3" style={{ marginLeft: 0 }}>
                <div
                  className="row align-items-end mx-auto"
                  style={{ marginTop: 20, width: "95%" }}
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  <div className="col">
                    <TextField
                      key="textField-waitlist-name"
                      id="standard-basic"
                      label={
                        language == "english" ? "Full Name" : "الاسم الكامل"
                      }
                      color="primary"
                      name="FullName"
                      style={{ width: "100%" }}
                      value={this.state.FullName}
                      onChange={(e) => {
                        this.handleChange(e);
                        this.setState({ NameError: false });
                      }}
                      InputLabelProps={{
                        style: {
                          right: language == "arabic" && -5,
                          left: language == "arabic" && "auto",
                        },
                        dir: language == "english" ? "ltr" : "rtl",
                      }}
                      InputProps={{
                        dir: language == "english" ? "ltr" : "rtl",
                      }}
                      error={this.state.NameError}
                      helperText={
                        this.state.NameError
                          ? language == "english"
                            ? "This field is required"
                            : "هذه الخانة مطلوبة"
                          : ""
                      }
                      FormHelperTextProps={{
                        style: {
                          textAlign: language == "arabic" && "right",
                          marginRight: language == "arabic" && 5,
                        },
                      }}
                    />
                  </div>
                  <div className="col ">
                    <TextField
                      key="textField-waitlist-numberofpeople"
                      type={"number"}
                      classes={{ root: "nowrap" }}
                      id="standard-basic"
                      label={
                        language == "english"
                          ? "Number of People"
                          : "عدد الأشخاص"
                      }
                      color="primary"
                      onChange={(e) => {
                        this.handleChange(e);
                        this.setState({
                          PeopleNumberRequiredError: false,
                          PeopleNumberError: false,
                        });
                      }}
                      value={this.state.NoPeople}
                      style={{ width: "100%" }}
                      error={
                        this.state.PeopleNumberRequiredError ||
                        this.state.PeopleNumberError
                      }
                      helperText={
                        this.state.PeopleNumberRequiredError
                          ? language == "english"
                            ? "This field is requried"
                            : "هذه الخانة مطلوبة"
                          : this.state.PeopleNumberError
                          ? language == "english"
                            ? `The maximum number is ${wait_list.maximum_number_of_seats}`
                            : `الحد الأقصى ${wait_list.maximum_number_of_seats}`
                          : ""
                      }
                      name="NoPeople"
                      InputLabelProps={{
                        style: {
                          right: language == "arabic" && -5,
                          left: language == "arabic" && "auto",
                        },
                        dir: language == "english" ? "ltr" : "rtl",
                      }}
                      InputProps={{
                        dir: "ltr",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="row align-items-end "
                  style={{ marginTop: 20, width: "98%" }}
                >
                  <MuiPhoneNumber
                    defaultCountry={country}
                    onlyCountries={[
                      "kw",
                      "sa",
                      "qa",
                      "om",
                      "ae",
                      "bh",
                      "sy",
                      "lb",
                      "jo",
                      "eg",
                      "us",
                      "uk",
                      "cn",
                    ]}
                    style={{ width: "100%", marginLeft: "45px" }}
                    name="PhoneNumber"
                    countryCodeEditable={false}
                    disableAreaCodes={true}
                    error={this.state.PhoneNumberError}
                    autoComplete="tel"
                    label={language == "english" ? "Phone *" : "رقم الهاتف *"}
                    className="my-4"
                    onChange={(number, dialcode) => {
                      this.setState({
                        PhoneNumberError: false,
                        PhoneNumber: number,
                        CountryCode: dialcode.dialCode,
                      });
                    }}
                    value={this.state.PhoneNumber}
                    helperText={
                      this.state.phoneError
                        ? language == "english"
                          ? "Please enter your phone number"
                          : "الرجاء ادخال رقم الهاتف"
                        : ""
                    }
                    FormHelperTextProps={{
                      style: {
                        textAlign: language == "arabic" && "right",
                        marginRight: language == "arabic" && 5,
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        right: language == "arabic" && -9,
                        left: language == "arabic" && "auto",
                      },
                      dir: language == "english" ? "ltr" : "rtl",
                    }}
                  />
                </div>
                <div
                  className={`row mt-3  align-items-center justify-content-start  ${
                    language === "english" ? "float-left ml-4" : "float-right"
                  }`}
                >
                  <div className="col">
                    <FormControlLabel
                      onChange={(e) =>
                        this.setState({ SpecialNeeds: e.target.checked })
                      }
                      control={<Checkbox value="checkedC" />}
                      label={
                        language === "english"
                          ? "Special Needs"
                          : "احتياجات خاصة"
                      }
                    />
                  </div>
                  <div className="col">
                    <FormControlLabel
                      onChange={(e) =>
                        this.setState({ Pregnant: e.target.checked })
                      }
                      control={<Checkbox value="checkedC" />}
                      label={language === "english" ? "Pregnant" : "حامل"}
                    />
                  </div>
                </div>
              </div>
              <div
                className="free-space-115"
                style={{ backgroundColor: "white" }}
              ></div>
              <Button
                className="mt-1 text-left"
                color="secondary"
                variant="outlined"
                onClick={() =>
                  this.props.history.push("/waitlist/track", {
                    waiting_list:
                      this.props.history.location.state.waiting_list,
                  })
                }
              >
                {language === "english"
                  ? "Already in the waiting list?"
                  : "في قائمة الإنتظار؟ "}
              </Button>
              <div
                className="free-space-115"
                style={{ backgroundColor: "white" }}
              ></div>
            </>
          )}
        </div>
        <ActionButton
          allowWithMenu
          onClick={async () => {
            let error = false;
            if (!this.state.FullName.trim()) {
              this.setState({ NameError: true });
              error = true;
            }
            if (
              !this.state.NoPeople ||
              (this.state.NoPeople &&
                (!this.is_numeric(this.state.NoPeople) ||
                  this.state.NoPeople <= 0))
            ) {
              this.setState({ PeopleNumberRequiredError: true });
              error = true;
            } else if (
              wait_list.maximum_number_of_seats &&
              this.state.NoPeople > wait_list.maximum_number_of_seats
            ) {
              this.setState({ PeopleNumberError: true });
              error = true;
            }
            if (!this.state.CountryCode) {
              this.setState({ PhoneNumberError: true });
              error = true;
            }
            if (!isValidPhoneNumber(this.state.PhoneNumber)) {
              this.setState({ PhoneNumberError: true });
              error = true;
            }
            if (!error) {
              this.setState({ loading: true });
              let request = await instance.post("/add_waitlist_entry/", {
                customer_name: this.state.FullName,
                customer_phone: this.state.PhoneNumber,
                customer_size: this.state.NoPeople,
                customer_special_needs: this.state.SpecialNeeds,
                customer_pregnant: this.state.Pregnant,
                customer_country_code: this.state.CountryCode,
                waiting_list: this.props.history.location.state.waiting_list.id,
              });
              let data = request.data;

              if (data.success) {
                request = await instance.get(
                  `/api/waiting/track?tracking_id=${data.data[0].tracking_id}&waiting_list=${this.props.location.state.waiting_list.id}`
                );
                let data2 = request.data;
                if (data2.success) {
                  this.props.history.push("/waitlist/status/", {
                    data: data2.data[0],
                    tracking_id: data.data[0].tracking_id,
                    waiting_list:
                      this.props.history.location.state.waiting_list,
                  });
                }
              }
              this.setState({
                failed: true,
              });
            }
          }}
          action={this.props.language == "english" ? "Register" : "سجل"}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WaitListForm);
